<div class="container">
  <div class="row">
  <div class="staticPages">

  <div data-language="bg"  *ngIf="selectedLang === 'bg'">
  <h1>Въпроси, препоръки, контакти</h1>
<p>Не се колебайте да изразите мнение и препоръка. <br> Сайтът е изграден и подобряван на база нуждите на бизнеса и неговия потребител. Ще очакваме Вашата обратна връзка, а Вие очаквайте нашата ;) Приемаме информация относно затворени обекти, променена локация, нелоялно отношение на бизнеса, похвали и други. Относно останалото, моля пишете на мейлите по-долу:</p>

  <h2>Въпроси относно поддръжка</h2>
        <i class="fa fa-envelope"></i> <a href="mailto:support@zavedenia.com" class="link"> support&#64;zavedenia.com
        </a>

  <h2>Въпроси относно реклама</h2>
        <i class="fa fa-envelope"></i> <a href="mailto:advertising@zavedenia.com" class="link"> advertising&#64;zavedenia.com</a>
  <br><br><br>
      <!--<br>Моля, попълнете формата и ние ще се свържем с Вас.
  Благодарим Ви! <br><br>
    <table width="90%" cellpadding="0" cellspacing="0" border="0" class="forma">
    <form action="feedback" name="cont" method="post"></form>
    <input type="hidden" name="sendit" value="1">
    <tbody><tr>
    <td width="110">Вашето име:</td>
    <td><input type="text" name="fname" class="input200"></td>

    </tr>
    <tr>
    <td>Заведение: </td>
    <td><input type="text" name="company" class="input200"></td>
    </tr>

    <tr>
    <td>Email:</td>
    <td><input type="text" name="email" class="input200"></td>
    </tr>
    <tr>
    <td>Телефон</td>
    <td><input type="text" name="phone" class="input200"></td>
    </tr>
    <tr>
    <td valign="top">Съобщение</td>
    <td><textarea name="text" cols="20" rows="5" style="width:200px;"></textarea></td>
    </tr>
    <tr><td></td><td><input type="submit" value="Изпрати" class="input100"></td>
      </tr>

    </tbody></table>-->

          <h1>Често задавани въпроси</h1>
    <h2>Аз съм собственик на бизнес:</h2>
    <p style="text-align:justify">
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Как да регистрирам заведение? </b><br>
        Всеки, който желае да представи своя обект подобаващо в интернет, може да се свърже с нас на посочените телефони (по градове) в секция Контакти или да изпрати запитване от бутон "За Бизнеса", в главното меню на сайта. Съществуват няколко варианта за представянето Ви. Нека заедно преценим кой е най-подходящият във вашия случай. <br>
        <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Как да се свържа с администратор при проблем, въпрос или оплакване? </b><br>
        Ако имате проблем с функционалността на сайта, въпрос или оплакване, може да се свържете с администратор на посочения мейл: <a href="mailto:nakata@zavedenia.com">nakata&#64;zavedenia.com</a>  Прегледайте инструкциите за въвеждане и редактиране на информация, преди да се свържете с нас.<br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Какви други варианти за реклама и/или партньорство предлагате? </b><br>
            Условията за реклама можете да намерите тук: <a href="http://sofia.zavedenia.com/page/howto/">РЕКЛАМА</a>. Попитайте нашите търговци за пакетни предложения за допълнителна банер реклама, тематични публикации, промоционални игри, изработка на персонален уебсайт.<br>
            При желание за партньорство, моля свържете се с нас, за да обсъдим допирните ни точки и как може да сме си взаимно полезни.<br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Защо именно Zavedenia.com?</b><br>
            Вече повече от 15 години разработваме, усъвършенстваме и внедряваме услуги в полза на малки ресторантьорски и хотелиерски бизнес. Познаваме пазара добре и сме намерили решение на по-голямата част от въпросите Ви. Само попитайте! Предлагаме отлични пакетни условия за стартиращ бизнес - от А до Я. Нашите партньори от Booky.bg и Order.bg ще съдействат за цялотното Ви представяне пред аудиторията.
      <br><br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Как мога да участвам в Sofia Restaurant Week, ако съм клиент на Zavedenia.com?</b><br>
            Екип на събитието обсъжда и оценява желаещите за участие кандидати. Критериите са няколко и, ако Вашето заведение отговаря на тях, имате реален шанс.
      <br><br>
    </p>
    <h2>Аз съм потребител:</h2>
    <p style="text-align:justify">
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Защо не мога да коментарам дадено заведение? </b><br>
        При злоупотреба, използване на обиден език, нецензурни думи и т.н. е възможно Вашите мнения да бъдат изтрити или ограничени. Коментарите могат да бъдат забранени както от екипа  на сайта, така и от регистрираните заведения. <br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Търся нещо определено и не мога да го открия. Как да го намеря? </b><br>
        Ако сте сигурни, че оббектът, който търсите фигурира при нас, използвайте търсачката в главното меню. Понякога заведенията се изписват и на латиница.<br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Търся заведение за специален повод и/или тип кухня</b><br>
      В нашия каталог наистина ще срещнете голямо разнообразие от опции къде да прекарате една хубава вечер, специален празник или да ядете люббимата си италианска кухня. Затова сме отделили отделни секции, през които филтрирайки предпочитанията си, ще стигнете бързо до точното заведение. А ако не сте сигурни - пишете ни. Дайте ни повече информация за предстоящото събитие, а ние ще ви върнем идеи къде да го отбележите ;) Пишете ни и на нашата Facebook страница.<br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Имам някои интересни предложения. Къде мога да ги представя?</b> <br>
        Всякакви предложения, въпроси и коментари може да споделяте с нас през страницата за обратна връзка. Някой от нашите редактори или администратори ще Ви отговорят възможно най-скоро.<br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> От какво зависи ценовата категория на заведението?</b><br>
        Ценовата категория се определя от собствениците на съответното заведение. Zavedenia.com не гарантира че тази информация е изцяло достоверна. Стремим се да сме максимално актуални и благодарим на всички, които ни информираха за забелязани неточности. <br>
        <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> До колко е актуално представянето на заведенията?</b><br>
        Една от основните цели на регистрираните обекти е да дават точна и пълна информация на потребителите на сайта. Винаги е възможно някакво разминаване, поради динамиката в бранша - промяна на визия, меню, цени. Заведенията се стремят своевременно да актуализират представянето си. <br>
        <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Мога ли да поръчам храна за вкъщи/ за офиса? </b><br>
        Може да поръчате храна за вкъщи или да разгледате актуалното меню (със снимки) на повечето заведения, като ще бъдете пренасочени към партньорски сайт Order.bg Действителните поръчки и доставки се осъществяват от там. <br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Изпратих ви моята история, но Вие не я публикувахте. Защо? </b><br>
            Ако дадена информация изпратена от наш потребител не бъде публикувана, то тя не отговаря на изискванията или тематиката в страницата.<br>
      <br>
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b class="bold"> Имате друг въпрос?</b><br>
            Ако имате въпрос, чиито отговор не сте намерили тук, пишете ни на e-mail адрес <a href="mailto:info@zavedenia.com">info&#64;zavedenia.com</a>. Благодарим!<br>
    </p>
  </div>
  <div data-language="sr" *ngIf="selectedLang === 'sr'">
    <h1>Pitanja, preporuke, kontakti</h1>
    <p>Ne oklevajte da izrazite mišljenje i preporuku. <br> Sajt je napravljen i unapređivan na osnovu potreba biznisa i njegovih korisnika. Očekujemo vašu povratnu informaciju, a vi očekujte naš odgovor ;) Prihvatamo informacije o zatvorenim objektima, promenjenim lokacijama, nelojalnom ponašanju, pohvalama i drugim temama. Za ostale informacije, pišite na mejlove ispod:</p>

    <h2>Pitanja o podršci</h2>
    <i class="fa fa-envelope"></i> <a href="mailto:support@zavedenia.com" class="link">support&#64;zavedenia.com</a>

    <h2>Pitanja o oglašavanju</h2>
    <i class="fa fa-envelope"></i> <a href="mailto:advertising@zavedenia.com" class="link">advertising&#64;zavedenia.com</a>

    <h1>Često postavljana pitanja</h1>
    <h2>Ja sam vlasnik biznisa:</h2>
    <p style="text-align:justify">
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Kako da registrujem lokal?</b><br>
      Svi koji žele da predstave svoj objekat online, mogu nas kontaktirati putem telefona (po gradovima) u sekciji Kontakti ili poslati upit preko dugmeta "Za biznise" u glavnom meniju sajta. Postoji više opcija za predstavljanje – hajde da zajedno izaberemo najbolju za vas.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Kako da kontaktiram administratora?</b><br>
      Za tehničke probleme, pitanja ili žalbe, obratite se administratoru putem mejla: <a href="mailto:nakata@zavedenia.com">nakata&#64;zavedenia.com</a>. Pročitajte uputstva pre kontaktiranja.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Koje još opcije oglašavanja nudite?</b><br>
      Detalje o oglašavanju pronađite ovde: <a href="http://sofia.zavedenia.com/page/howto/">REKLAMA</a>. Nudimo banerske kampanje, tematske objave, izradu sajta itd. Za partnerstva nas kontaktirajte.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Zašto baš Zavedenia.com?</b><br>
      Već više od 15 godina radimo za male ugostitelje i hotelijere. Znamo tržište, imamo rešenja i povoljne pakete za startape. Partneri Booky.bg i Order.bg će pomoći u prezentaciji.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Kako da učestvujem u Sofia Restaurant Week?</b><br>
      Organizatori biraju kandidate prema kriterijumima. Ako vaš lokal ispunjava uslove, imate šansu da učestvujete.<br><br>
    </p>

    <h2>Ja sam korisnik:</h2>
    <p style="text-align:justify">
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Zašto ne mogu da komentarišem?</b><br>
      Komentari mogu biti uklonjeni zbog uvredljivog jezika. Mogu ih onemogućiti i tim sajta i lokali.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Kako da nađem to što tražim?</b><br>
      Koristite pretragu u glavnom meniju. Imajte u vidu da se neka imena pišu latinicom.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Tražim lokal za posebnu priliku ili tip kuhinje</b><br>
      U našem katalogu možete filtrirati po tipu kuhinje, atmosferi itd. Ako niste sigurni – pišite nam, daćemo vam preporuke. Možete nas kontaktirati i na Facebooku.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Imam zanimljive predloge. Gde da ih pošaljem?</b><br>
      Pošaljite ih putem stranice za kontakt. Naš tim će vam odgovoriti.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Ko određuje cenovne kategorije?</b><br>
      Vlasnici lokala ih određuju. Zavedenia.com ne garantuje tačnost, ali se trudimo da budu ažurne.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Koliko su tačni podaci o lokalima?</b><br>
      Promene u meniju, cenama i izgledu su česte, ali lokali se trude da budu ažurni.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Mogu li da naručim hranu?</b><br>
      Možete, i bićete preusmereni na Order.bg gde su aktuelni meniji i naručivanje.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Zašto moja priča nije objavljena?</b><br>
      Možda ne ispunjava pravila ili temu sajta.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Imate drugo pitanje?</b><br>
      Pišite na <a href="mailto:info@zavedenia.com">info&#64;zavedenia.com</a>. Hvala!<br>
    </p>
  </div>
  <div data-language="mk" *ngIf="selectedLang === 'mk'">
    <h1>Прашања, препораки, контакти</h1>
    <p>Не двоумете се да дадете мислење или препорака. <br> Сајтот е направен и подобруван според потребите на бизнисите и нивните корисници. Го очекуваме вашиот фидбек, а вие очекувајте наш одговор ;) Прифаќаме информации за затворени локали, променета локација, нелојално однесување, пофалби и друго. За сè останато, пишете на е-поштите подолу:</p>

    <h2>Прашања за техничка поддршка</h2>
    <i class="fa fa-envelope"></i> <a href="mailto:support@zavedenia.com" class="link">support&#64;zavedenia.com</a>

    <h2>Прашања за рекламирање</h2>
    <i class="fa fa-envelope"></i> <a href="mailto:advertising@zavedenia.com" class="link">advertising&#64;zavedenia.com</a>

    <h1>Најчесто поставувани прашања</h1>
    <h2>Јас сум сопственик на бизнис:</h2>
    <p style="text-align:justify">
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Како да регистрирам локал?</b><br>
      Контактирајте нè преку телефоните во делот Контакти или преку копчето "За Бизниси" во главното мени. Ќе ви понудиме неколку опции и ќе избереме најсоодветна.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Како да контактирам администратор?</b><br>
      За технички прашања, проблеми или поплаки, пишете на: <a href="mailto:nakata@zavedenia.com">nakata&#64;zavedenia.com</a><br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Кои други видови рекламирање нудите?</b><br>
      Повеќе инфо тука: <a href="http://sofia.zavedenia.com/page/howto/">РЕКЛАМА</a>. Нудиме банери, статии, веб-сајтови и игри. За партнерство, јавете се.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Зошто Zavedenia.com?</b><br>
      Повеќе од 15 години работиме со угостители. Нудиме одлични пакети и целосна промоција со Booky.bg и Order.bg.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Како да учествувам во Sofia Restaurant Week?</b><br>
      Кандидатите се разгледуваат според критериуми. Ако ги исполнувате – имате шанса.<br><br>
    </p>

    <h2>Јас сум корисник:</h2>
    <p style="text-align:justify">
      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Зошто не можам да коментирам?</b><br>
      Коментарите може да бидат избришани поради навредлив говор. Локалите и сајтот можат да ги ограничат.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Како да најдам тоа што го барам?</b><br>
      Користете ја пребарувачката. Некои имиња се пишуваат на латиница.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Барам локал за специјална пригода или кујна</b><br>
      Користете ги филтрите по кујна, атмосфера и локација. Ако не знаете – пишете ни, ќе ви предложиме нешто.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Имам предлози. Каде да ги испратам?</b><br>
      Испратете ги преку страната за контакт. Ќе одговориме наскоро.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Кој ја одредува ценовната категорија?</b><br>
      Сопствениците. Zavedenia.com не гарантира точност, но се трудиме да бидеме ажурни.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Колку е ажурна содржината?</b><br>
      Информациите може да се менуваат, но објектите се трудат да ги одржуваат точни.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Може ли да нарачам храна?</b><br>
      Да, преку Order.bg каде се прават и самите нарачки.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Испратив приказна, но не е објавена. Зошто?</b><br>
      Можеби не одговара на темата или условите.<br><br>

      <i class="fa fa-question-circle" aria-hidden="true"></i> <b>Имате друго прашање?</b><br>
      Пишете ни на <a href="mailto:info@zavedenia.com">info&#64;zavedenia.com</a>. Благодариме!<br>
    </p>
  </div>



  </div>
  </div>
  </div>
